var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"ml3 mt3 mr4\"> <div class=\"flex justify-start ml3 icon-border-compensating\"> <bds-icon type=\"logo\" name=\"whatsapp\" size=\"brand\"/> </div> </div>";
ngModule.run(["$templateCache",function(c){c.put("WhatsAppIcon.html",v1)}]);
module.exports=v1;